import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Card, Container, Row, Col, CardBody, CardHeader } from 'react-bootstrap'
import Loader3 from '../../../../CommonElements/Spinner/loader3'
import { RecentOrderChart } from "./analytics_data_temp";
import ReactApexChart from "react-apexcharts";
import { ArrowDown, ArrowUp, Filter } from "react-feather";
import "../AIModelReports/custom.css";
import { errorToast, getWeek } from "../../../../_helper/helper";
import { dummyJSON, Shifts } from "../../../../Data/staticData/data";
import ApexInteractiveHeatmap from "./components/HeatMap";
import ProgressBars from "./components/ProgressBars";
import AlertsTrendChart from "./components/AlertsTrendChart";
import AreaService from "../../../../api/areaService";
import { getCurrentWeekNumber } from "../../../../utils/getCurrentWeekNumber";
import CameraService from "../../../../api/cameraService";
import { getCurrentWeekWithYear } from "../../../../utils/currentWeekWithYear";
import { analyticsPageService } from "../../../../api/analyticsPageService";
import CommonFIlterButton from "../../../Common/commonFilterButton/CommonFIlterButton";
import { Input } from "reactstrap";
import './components/alertTrend.css'
import { LuBuilding2 } from "react-icons/lu";
import { TiLocationArrowOutline } from "react-icons/ti";
import { GoLocation } from "react-icons/go";
import { MdAccessTime } from "react-icons/md";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { TbAlertSquareRounded } from "react-icons/tb";
import { FaCamera } from "react-icons/fa";
import { GiCctvCamera } from "react-icons/gi";
import { formatMonth, formatWeek } from "../../../../utils/formatDate";
import { Typeahead } from "react-bootstrap-typeahead";
import { getSharedFilters, updateSharedFilters } from "../../../../utils/filters/shareFilters";
import LiveAnalyticsContext from "../../../../_helper/formData/LiveAnalytics/LiveAnalytics";

import CommonHeading from "../../../Common/commonHeading/CommonHeading";
import AnalyticsPage from "./AnalyticsPage";
const LiveAnalyticsScreen = () => {
  const [currentWeekWithYear, setcurrentWeekWithYear] = useState(getCurrentWeekWithYear())

  const { wholePageSS } = useContext(LiveAnalyticsContext)

  const shared = getSharedFilters();
  const [filters, setFilters] = useState({
    weekly: !shared?.weekly && !shared?.month ? getCurrentWeekWithYear() : shared?.weekly ? shared?.weekly : '',
    month: !shared?.weekly ? (shared?.month || '') : "",
    shift: Array.isArray(shared?.shift) ? shared.shift : (shared?.shift ? [String(shared.shift)] : []),
  });

  useEffect(() => {
    let fils = JSON.parse(localStorage.getItem('dashfilters'))
    if (!fils) {
      localStorage.setItem('dashfilters', JSON.stringify(filters))
      updateSharedFilters(filters)
    }
  }, [filters]);

  const typeHeadChange = (field, selected) => {
    setFilters((prev) => {
      const value = Array.isArray(selected) ? selected.map(String) : [];
      const update = { ...prev, [field]: value };
      localStorage.setItem("dashfilters", JSON.stringify(update));
      updateSharedFilters(update);
      return update;
    });
  };

  const handleWeekChange = (e) => {
    const { value } = e.target;

    setFilters((prev) => {
      const update = {
        ...prev,
        month: "",
        weekly: !value ? getCurrentWeekWithYear() : value,
      };

      localStorage.setItem("dashfilters", JSON.stringify(update));
      updateSharedFilters(update)
      return update;
    });
  };

  const handleMonthChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => {
      const update = {
        ...prev,
        weekly: "",
        [name]: value,
      };

      localStorage.setItem("dashfilters", JSON.stringify(update));
      updateSharedFilters(update)
      return update;
    });
  };

  const [showFilters, setShowFilters] = useState(false);
  const filterCardRef = useRef(null);
  const filterButton = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        filterCardRef.current &&
        filterButton.current &&
        !filterCardRef.current.contains(event.target) &&
        !filterButton.current.contains(event.target)
      ) {
        setShowFilters(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilters]);

  const filterButtonstyle = {
    width: "155px",
    height: "38px",
    fontSize: 13,
    margin: "0",
  };

  return (
    <Fragment>
      <br />
      <Container ref={wholePageSS} fluid={true}>

        <Row className="d-flex justify-content-center mb-2 px-1">
          <Col xs="12" sm="7" md="6" className="pt-1">
            <CommonHeading text={'Live Analytics'} padding={'pb-0 '} />
            <p className="f-light mt-0">{filters?.weekly ? `${formatWeek(filters.weekly)} Data` : filters?.month ? `${formatMonth(filters.month)} Data` : 'Current week'}</p>
          </Col>
          <Col
            xs="12"
            sm="5"
            md="6"
            className=" d-flex flex-row flex-md-row flex-column mt-2 mt-sm-0 flex-wrap justify-content-end align-items-end filter-container align-self-end"
          >
            <div
              type="button"
              className={`d-flex justify-content-center filter-btnn  ${showFilters && "border_R"
                }`}
              ref={filterButton}
              onClick={() => setShowFilters(!showFilters)}
            >
              <p className="m-0" style={{ fontSize: "16px" }}>
                Filters
              </p>
              <span className="d-flex">
                <Filter color="#fff" size={16} className="ms-2 " />
              </span>
            </div>
            <div className="w-100 d-flex justify-content-end position-relative">
              {showFilters && (
                <div
                  className={`d-flex align-items-center justify-content-center py-3 gap-2 filter-card flex-wrap shadow-sm`}
                  ref={filterCardRef}
                >
                  <Typeahead
                    id="shift"
                    style={{ minWidth: '112px', width: '155px', fontSize: 13 }}
                    multiple
                    clearButton
                    options={['Shift A', 'Shift B', 'Shift C']}
                    labelKey={(option) => option}
                    selected={filters.shift || []}
                    placeholder="Select Shift"
                    onChange={(selected) => typeHeadChange('shift', selected)}
                  />

                  <div className="d-flex rounded-3 position-relative flex-column justify-content-center gap-2 flex-md-row flex-wrap">
                    {!filters?.weekly && (
                      <span className="filters-weekly-span">Select Week</span>
                    )}
                    <Input
                      className={`filter-button-size margin-for-weekly input-border-class-weekly m-0`}
                      type="week"
                      name="week"
                      id="week"
                      max={getCurrentWeekWithYear()}
                      value={filters.weekly || ""}
                      placeholder="Select Week"
                      style={{ ...filterButtonstyle }}
                      onChange={handleWeekChange}
                    />
                    {!filters.month && (
                      <span className="filter-month-span">Select Month</span>
                    )}
                    <Input
                      className={`filter-button-size input-border-class-month m-0`}
                      type="month"
                      name="month"
                      id="month"
                      max={new Date().toISOString().slice(0, 7)}
                      value={filters.month || ""}
                      style={{ ...filterButtonstyle }}
                      onChange={handleMonthChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>

        <AnalyticsPage filters={filters} />
      </Container>
    </Fragment>
  );
};

export default LiveAnalyticsScreen;
